import {
  API_CALL,
  REDEEM_GIFT_CARD,
  CLEAR_REDEEMED_GIFT_CARDS,
  REMOVE_REDEEMED_GIFT_CARD,
} from './actionConstants'
import { FETCH_GIFT_CARD } from './apiActionConstants'
import { getGiftCard } from 'api/promo'
import { RedeemedCard } from 'components/Common/RedeemGiftCard/common'

export function fetchGiftCard(code: string) {
  return {
    type: API_CALL,
    api: FETCH_GIFT_CARD,
    request: () => getGiftCard(code),
  }
}

export function redeemGiftCard(card: RedeemedCard) {
  return {
    type: REDEEM_GIFT_CARD,
    card,
  }
}

export function clearRedeemedGiftCards() {
  return {
    type: CLEAR_REDEEMED_GIFT_CARDS,
  }
}

export function removeRedeemedGiftCard(code: string) {
  return {
    type: REMOVE_REDEEMED_GIFT_CARD,
    code,
  }
}
